import { MarkedOptions, MarkedRenderer } from 'ngx-markdown';

export function markedOptionsFactory(): MarkedOptions {
    const renderer = new MarkedRenderer();
    renderer.blockquote = (text: string) => {
        return '>' + text + '';
    };
    renderer.paragraph = (text: string) => {
        return '<span class="markdown-paragraph">' + text + '</span>';
    };
    renderer.listitem = (text: string) => {
        return '<li class="markdown-list-item">' + text + '</li>';
    };
    return {
        breaks: false,
        gfm: true,
        pedantic: false,
        renderer: renderer,
    };
}
